import React, { useState, useEffect } from "react";
import Sidebar from '../../../composant_reutilisable/sidebar';
import Navbar from "../../../composant_reutilisable/navbar";
import useAuth from '../../../composant_reutilisable/useAuth';
import { Link } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import {
    FaEdit, FaPlus, FaTrash, FaEllipsisV,
    FaSortAmountUp, FaSortAmountDown,
    FaArrowLeft,
    FaArrowRight,
    FaBoxOpen,
    FaLeaf,
    FaFileImport,
    FaChevronUp,
    FaChevronDown,
    FaQuestionCircle,
    FaBuilding,
    FaBus
} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Pas_acces from "../../../composant_reutilisable/pas_acces";
import Select from 'react-select';

const ListeCategorie = () => {
    useAuth();
    const navigate = useNavigate();

    const [showInfo, setShowInfo] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({
        key: "id",
        direction: "descending",
    });
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });

    const [natures, setNatures] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showModifierModal, setShowModifierModal] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [showTypesModal, setShowTypesModal] = useState(false);

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Catégories";
        }
    }, [user_id]);

    const [showModal, setShowModal] = useState(false);
    const [nouvelleNature, setNouvelleNature] = useState({ nom_categorie: "" });
    const [natureSelectionnee, setNatureSelectionnee] = useState({ nom_categorie: "" });

    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key, direction });
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
        setAlertModal({ message: '', type: '' });
    }

    // Récupération des categories
    const fetchNatures = async () => {
        const token = localStorage.getItem('access_token')
        try {
            setIsLoading(true);
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-categories/",
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
            if (response.ok) {
                const data = await response.json();
                setNatures(data);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Erreur lors de la récupération des categories:", error);
        }
    };

    useEffect(() => {
        fetchNatures();
    }, []);

    // Filtrage
    const naturesFiltrees = natures.filter(nature =>
        nature?.ref_categorie?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        // nature?.date_creation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        nature?.nom_categorie?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Tri des données
    const naturesTriees = [...naturesFiltrees].sort((a, b) => {
        if (sortConfig.key) {
            const valueA = a[sortConfig.key]?.toString().toLowerCase() || "";
            const valueB = b[sortConfig.key]?.toString().toLowerCase() || "";
            if (valueA < valueB) return sortConfig.direction === "ascending" ? -1 : 1;
            if (valueA > valueB) return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
    });

    // Pagination
    const totalItems = naturesFiltrees.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const naturesAffichees = naturesTriees.slice(indexOfFirstItem, indexOfLastItem);

    const handleSelectionNature = (nature) => {
        setNatureSelectionnee(nature);
    };

    // Gestion du modal
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    // Gestion du formulaire d'ajout
    const handleChange = (e) => {
        const { name, value } = e.target;
        setNouvelleNature(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAjouterNature = async () => {
        const erreurs = [];

        // if (!nouvelleNature.ref_categorie.trim()) {
        //     erreurs.push("La référence de la categorie est obligatoire.");
        // }

        if (!nouvelleNature.nom_categorie.trim()) {
            erreurs.push("Le nom de la catégorie est obligatoire.");
        }

        if (erreurs.length > 0) {
            showAlertModal(erreurs.join(" "), "danger");
            return;
        }

        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-categorie/${user_id}/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(nouvelleNature),
            });

            if (response.ok) {
                fetchNatures();
                setNouvelleNature({ nom_categorie: "" });
                handleCloseModal();
                showAlert("Categorie ajoutée avec succès", "success");
            } else {
                const errorData = await response.json();
                showAlertModal(errorData.message || "Erreur lors de l'ajout de la categorie", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlertModal("Une erreur est survenue. Veuillez réessayer.", "danger");
        }
    };

    const handleShowDeleteModal = (nature) => {
        setNatureSelectionnee(nature);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const handleDeleteNature = async () => {
        if (natureSelectionnee) {
            const token = localStorage.getItem('access_token');
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-categorie/${natureSelectionnee.id}/${user_id}/`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });

                if (response.ok) {
                    setNatures(natures.filter((nature) => nature.id !== natureSelectionnee.id));
                    setNatureSelectionnee(null);
                    showAlert('Categorie supprimée avec succès !');
                } else {
                    console.error('Erreur lors de la suppression de cette categorie');
                    showAlert('Erreur lors de la suppression', 'danger');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
                showAlert('Erreur réseau', 'danger');
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const handleShowModifierModal = (nature) => {
        setNatureSelectionnee(nature);
        setShowModifierModal(true);
    };

    const handleCloseModifierModal = () => {
        setShowModifierModal(false);
    };

    const handleModifierNature = async () => {
        if (natureSelectionnee) {
            const erreurs = [];


            if (!natureSelectionnee.nom_categorie.trim()) {
                erreurs.push("Le nom de la categorie est obligatoire.");
            }

            if (erreurs.length > 0) {
                showAlertModal(erreurs.join(" "), "danger");
                return;
            }

            const token = localStorage.getItem('access_token');
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/modifier-categorie/${natureSelectionnee.id}/${user_id}/`,
                    {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            // ref_categorie: natureSelectionnee.ref_categorie,
                            nom_categorie: natureSelectionnee.nom_categorie
                        }),
                    }
                );

                if (response.ok) {
                    fetchNatures();
                    showAlert('Catégorie modifiée avec succès !');
                } else {
                    console.error('Erreur lors de la modification de cette catégorie');
                    showAlert('Erreur lors de la modification', 'danger');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
                showAlert('Erreur réseau', 'danger');
            } finally {
                setShowModifierModal(false);
            }
        }
    };

    const handleShowTypesModal = (nature) => {
        setNatureSelectionnee(nature);
        recupererTypesCategorie(nature);
        setShowTypesModal(true);
    };

    const handleCloseTypesModal = () => {
        setShowTypesModal(false);
    };

    const [parametres, setParametres] = useState({ typeCamion: [], });
    const [typesCamions, setTypesCamions] = useState([]);
    const fetchTypesCamions = async () => {
        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-types/",
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
            if (response.ok) {
                const data = await response.json();

                const filteredTypes = data
                    .filter(type => type.option !== 'Tete')
                    .map(type => ({
                        value: type.id,
                        label: type.libelle
                    }));

                setTypesCamions(filteredTypes);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des types de camions:", error);
        }
    };

    useEffect(() => {
        fetchTypesCamions();
    }, []);

    const handleTypesCamionsChange = (selectedOptions) => {
        const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setParametres({
            ...parametres,
            typeCamion: selectedValues
        });
    };

    const enregistrerTypesCategorie = async () => {
        // setIsLoadingButton(true)
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/configurer-type_camion-categorie/${natureSelectionnee.id}/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    // parametres: {  // Notez la structure imbriquée
                    //     // ...parametres,
                    //     typeCamion: parametres.typeCamion  // Assurez-vous que ce champ est inclus
                    // },
                    //   user_id: user_id
                    type_camion: parametres.typeCamion
                }),
            });
            const data = await response.json();

            if (response.ok) {
                fetchNatures();
                showAlert(data.message, 'success');
            } else {
                showAlert(data.message, 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setShowTypesModal(false);
        }
    };

    const recupererTypesCategorie = async (natureSelectionnee) => {
        if (natureSelectionnee) {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/afficher-types_camions-par_categorie/${natureSelectionnee.id}/`,
                    {
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' },
                    }
                );

                const data = await response.json();

                if (response.ok) {
                    setParametres({
                        typeCamion: data.type_camion ? data.type_camion.map(t => t.id) : []
                    });
                } else {
                    showAlert(data.error || "Erreur lors de la récupération des types de categorie", 'danger');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
                showAlert("Erreur de connexion au serveur", 'danger');
            }
        }
    };


    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            const token = localStorage.getItem('access_token');
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                    });
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Elementaires")) {
        return (
            <Pas_acces />
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2></h2>
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaBuilding size={25} className='mr-2' /> Categorie
                                    {/* <span
                                        className="ml-3 toggle-icon"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setShowInfo(!showInfo)}
                                    >
                                        {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                    </span> */}
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation-admin', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'admin-elementaires'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <small>Administration des catégories.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Elementaires`}> Elémentaires</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Catégorie
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`m-3 alert alert-${alert.type} row justify-content-between position-relative`}>
                            <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des catégories</h5>
                            <div className="d-flex mt-md-0" style={{ gap: '10px' }}>
                                <button className="btn btn-success mr-2 d-flex align-items-center justify-content-center" onClick={handleOpenModal}>
                                    <FaPlus />
                                    <span className="d-none d-sm-inline ml-2">Ajouter</span>
                                </button>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="me-2">
                                                <select
                                                    value={itemsPerPage}
                                                    onChange={handleItemsPerPageChange}
                                                    className="form-select bg-default p-1"
                                                    style={{
                                                        width: "auto",
                                                        border: "1px black solid",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <option value={10}>10</option>
                                                    <option value={20}>20</option>
                                                    <option value={50}>50</option>
                                                </select>
                                            </div>
                                            <div className="row justify-content-center align-items-center">
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control mr-2"
                                                    style={{ maxWidth: "150px", width: "100%" }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                <thead>
                                                    <tr>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort("ref_categorie")}>
                                                            Référence
                                                            {sortConfig.key === "ref_categorie"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort("nom_categorie")}>
                                                            Nom de la catégorie
                                                            {sortConfig.key === "nom_categorie"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-center">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        <tr>
                                                            <td colSpan="2" className="text-center">Chargement...</td>
                                                        </tr>
                                                    ) : naturesAffichees.length > 0 ? (
                                                        naturesAffichees.map((nature) => (
                                                            <tr key={nature.id}>
                                                                <td className="d-none d-md-table-cell text-justify">{nature.ref_categorie}</td>
                                                                <td className="d-none d-md-table-cell text-justify">{nature.nom_categorie}</td>
                                                                <td className="text-center" style={{ position: 'relative' }}>
                                                                    <div>
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setOpenDropdownId(openDropdownId === nature.id ? null : nature.id);
                                                                            }}
                                                                            style={{
                                                                                background: 'none',
                                                                                border: 'none',
                                                                                padding: '0 5px',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        >
                                                                            <FaEllipsisV title="Actions" />
                                                                        </button>

                                                                        {openDropdownId === nature.id && (
                                                                            <div
                                                                                style={{
                                                                                    position: 'fixed',
                                                                                    zIndex: 1000,
                                                                                    minWidth: '150px',
                                                                                    right: '100px',
                                                                                    backgroundColor: 'white',
                                                                                    border: '1px solid #ddd',
                                                                                    borderRadius: '4px',
                                                                                    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                                                                    maxHeight: '150px',
                                                                                    overflowY: 'auto',
                                                                                    scrollbarWidth: 'thin',
                                                                                    scrollbarColor: '#ddd #f8f9fa',
                                                                                }}
                                                                                className="custom-scrollbar"
                                                                            >
                                                                                {/* <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleShowTypesModal(nature);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaBus className="mr-2" style={{ color: "blue" }} size={14} />
                                                                                    <span>Types</span>
                                                                                </div> */}

                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleShowModifierModal(nature);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaEdit className="mr-2" style={{ color: "blue" }} size={14} />
                                                                                    <span>Modifier</span>
                                                                                </div>

                                                                                <div style={{ borderTop: '1px solid #eee' }} />

                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleShowDeleteModal(nature);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaTrash className="mr-2" style={{ color: "red" }} size={14} />
                                                                                    <span>Supprimer</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="2" className="text-center">Aucune categorie de fret trouvée.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination */}
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div>
                                                {naturesFiltrees.length === 0
                                                    ? "Aucun élément à afficher"
                                                    : `Affichage de ${indexOfFirstItem + 1} à ${Math.min(indexOfLastItem, naturesFiltrees.length)} sur ${naturesFiltrees.length}`}
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <button
                                                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                                    className={`btn ${currentPage === 1 ? "btn-outline-secondary" : "btn-outline-primary"} mx-1`}
                                                    disabled={currentPage === 1}
                                                >
                                                    <FaArrowLeft />
                                                </button>

                                                {(() => {
                                                    const pagesToShow = 5;
                                                    let startPage = Math.max(
                                                        1,
                                                        currentPage - Math.floor(pagesToShow / 2)
                                                    );
                                                    let endPage = Math.min(
                                                        totalPages,
                                                        startPage + pagesToShow - 1
                                                    );

                                                    if (endPage - startPage < pagesToShow - 1) {
                                                        startPage = Math.max(
                                                            1,
                                                            endPage - pagesToShow + 1
                                                        );
                                                    }

                                                    const pageButtons = [];

                                                    for (let i = startPage; i <= endPage; i++) {
                                                        pageButtons.push(
                                                            <button
                                                                key={i}
                                                                onClick={() => setCurrentPage(i)}
                                                                className={`btn ${currentPage === i
                                                                    ? "btn-default"
                                                                    : "btn-light"
                                                                    } mx-1`}
                                                            >
                                                                {i}
                                                            </button>
                                                        );
                                                    }

                                                    return pageButtons;
                                                })()}
                                                <button
                                                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                                    className={`btn ${currentPage === totalPages ? "btn-outline-secondary" : "btn-outline-primary"} mx-1`}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <FaArrowRight />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal d'enregistrement */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header>
                    <Modal.Title>Ajouter une Catégorie</Modal.Title>
                </Modal.Header>
                {alertModal.message && (
                    <div className={`m-2 alert alert-${alertModal.type} row justify-content-between position-relative`}>
                        <div dangerouslySetInnerHTML={{ __html: alertModal.message }} />
                        <span onClick={fermerNotif} style={{ cursor: 'pointer' }}>
                            <i className='fa fa-close'></i>
                        </span>
                    </div>
                )}
                <Modal.Body>
                    <Form>

                        <Form.Group controlId="formNature">
                            <Form.Label className="mt-3">Nom de la catégorie</Form.Label>
                            <Form.Control
                                type="text"
                                name="nom_categorie"
                                value={nouvelleNature?.nom_categorie || ''}
                                onChange={handleChange}
                                placeholder="nom de la catégorie"
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        <strong>Annuler</strong>
                    </Button>
                    <Button variant="success" onClick={handleAjouterNature}>
                        <strong>Ajouter</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de confirmation de suppression */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header>
                    <Modal.Title>Confirmer la Suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir supprimer la catégorie de type <strong>{natureSelectionnee?.nom_categorie}</strong> ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        <strong>Annuler</strong>
                    </Button>
                    <Button variant="success" onClick={handleDeleteNature}>
                        <strong>Supprimer</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de modification */}
            <Modal show={showModifierModal} onHide={handleCloseModifierModal}>
                <Modal.Header>
                    <Modal.Title>Modifier la catégorie</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formNature">
                            <Form.Label className="">Nom de la catégorie</Form.Label>
                            <Form.Control
                                type="text"
                                value={natureSelectionnee?.nom_categorie || ''}
                                onChange={(e) =>
                                    setNatureSelectionnee({ ...natureSelectionnee, nom_categorie: e.target.value })
                                }
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModifierModal}>
                        <strong>Annuler</strong>
                    </Button>
                    <Button variant="success" onClick={handleModifierNature}>
                        <strong>Modifier</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de classement type par catégorie */}
            <Modal show={showTypesModal} onHide={handleCloseTypesModal}>
                <Modal.Header>
                    <Modal.Title>Types de catégorie</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Select
                        isMulti
                        options={typesCamions}
                        // value={typesCamions.filter(option =>
                        //     parametres.typeCamion.includes(option.value)
                        // )}
                        value={typesCamions.filter(option =>
                            Array.isArray(parametres.typeCamion) && parametres.typeCamion.includes(option.value)
                        )}
                        onChange={handleTypesCamionsChange}
                        placeholder="Sélectionnez un ou plusieurs types..."
                        className="basic-multi-select"
                        classNamePrefix="select"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseTypesModal}>
                        <strong>Annuler</strong>
                    </Button>
                    <Button variant="success" onClick={enregistrerTypesCategorie}>
                        <strong>Enregistrer</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default ListeCategorie;